import { getYMDFormatDTString, getYMDHMSFormatDTString } from "utils/dateUtil";
import axios from "./axios";
import { API_ERROR_CODE } from "./utils/dataCenter";

const prefix = "/v1/item";

export function getItemsSalesAndNangmanOrdersByPlant(
  COMPANY_ID: string,
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      const response = await axios.get(
        `${prefix}/getItemsSalesAndNangmanOrdersByPlant?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getItemsSalesAndNangmanOrdersByPlant error: `, e);
      reject(e);
    }
  });
}

// export function getLatestItemsRealInvAndSmartInvByPlant(
//   COMPANY_ID: string,
//   SHOP_ID: string
// ) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const searchParams = new URLSearchParams({
//         COMPANY_ID,
//         SHOP_ID,
//       });
//       const response = await axios.get(
//         `${prefix}/getLatestItemsRealInvAndSmartInvByPlant?${searchParams.toString()}`
//       );
//       resolve(response);
//     } catch (e) {
//       console.log(
//         `${prefix} getLatestItemsRealInvAndSmartInvByPlant error: `,
//         e
//       );
//       reject(e);
//     }
//   });
// }

// export function getOrderQtyAndUsagePerSalesByPlantAndIngredients( // 정량 조리율
//   COMPANY_ID: string,
//   SHOP_ID: string,
//   startDate: Date,
//   endDate: Date,
// ) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       startDate.setHours(0, 0, 0, 0);
//       endDate.setHours(23, 59, 59, 999);
//       const searchParams = new URLSearchParams({
//         COMPANY_ID,
//         SHOP_ID,
//         startDate: getYMDFormatDTString(startDate),
//         endDate: getYMDFormatDTString(endDate),
//       });
//       const response = await axios.get(
//         `${prefix}/getOrderQtyAndUsagePerSalesByPlantAndIngredients?${searchParams.toString()}`
//       );
//       resolve(response);
//     } catch (e) {
//       console.log(
//         `${prefix} getOrderQtyAndUsagePerSalesByPlantAndIngredients error: `,
//         e
//       );
//       reject(e);
//     }
//   });
// }
